export default  [
    {
      weekIndex: "",
      week: "全部",
      date: "",
    },
    {
      weekIndex: "1",
      week: "一月",
      date: "",
    },
    {
      weekIndex: "2",
      week: "二月",
      date: "",
    },
    {
      weekIndex: "3",
      week: "三月",
      date: "",
    },
    {
      weekIndex: "4",
      week: "四月",
      date: "",
    },
    {
      weekIndex: "5",
      week: "五月",
      date: "",
    },
    {
      weekIndex: "6",
      week: "六月",
      date: "",
    },
    {
      weekIndex: "7",
      week: "七月",
      date: "",
    },
    {
      weekIndex: "8",
      week: "八月",
      date: "",
    },
    {
      weekIndex: "9",
      week: "九月",
      date: "",
    },
    {
      weekIndex: "10",
      week: "十月",
      date: "",
    },
    {
      weekIndex: "11",
      week: "十一月",
      date: "",
    },
    {
      weekIndex: "12",
      week: "十二月",
      date: "",
    },
  ];


// WEBPACK FOOTER //
// ./src/service/constant/Month.js